import React from 'react';

import { APIEntityType } from '@cd3p/core/types/api';
import { Modal, Typography } from 'components';
import { useHandleApiResult } from 'hooks/useHandleApiResult';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useSensitiveData } from 'modules/sensitiveData';

import { sensitiveDataSelectors } from 'selectors';

type AccessAproveRejectModalProps = {
  onClose: () => void;
  onSuccess?: () => void;
  requestedEntityType?: APIEntityType;
  requestedEntityId?: string | number;
};

export const AccessAproveRejectModal: React.FC<
  AccessAproveRejectModalProps
> = ({ onClose, onSuccess, requestedEntityType, requestedEntityId }) => {
  const handleApiResult = useHandleApiResult();
  const { reviewSensitiveData } = useSensitiveData();
  const requestSensitiveDataPending = useSelector(
    sensitiveDataSelectors.requestSensitiveDataPending,
  );

  const { t } = useTranslation();

  const onSubmit = (isApproved: boolean) => async () => {
    if (!requestedEntityType || !requestedEntityId) {
      return;
    }
    handleApiResult(
      () =>
        reviewSensitiveData(requestedEntityType, requestedEntityId, {
          isApproved,
        }),
      () => {
        onSuccess?.();
        onClose?.();
      },
    );
  };
  return (
    <Modal
      open
      header={t('sensitiveData.requestModal.title')}
      confirmLabel={t('sensitiveData.decisionModal.approveLabel')}
      onConfirm={onSubmit(true)}
      isDisabled={requestSensitiveDataPending}
      isPending={requestSensitiveDataPending}
      onClose={onClose}
      onCancel={onSubmit(false)}
      cancelLabel={t('sensitiveData.decisionModal.rejectLabel')}
      // needed to stop propagation if modal is clicked inside material table row (from stakoverlow https://stackoverflow.com/questions/60436516/prevent-event-propagation-on-row-click-and-dialog-in-material-ui)
      onClick={e => e.stopPropagation()}
    >
      <Typography>{t('sensitiveData.decisionModal.description')}</Typography>
    </Modal>
  );
};
